function dynatraceInjection(t) {
  const locale = t('trust_arc_locale');
  // As of now Dynatrace script is configured and will be tested for baseline only.
  if (locale === 'baseline') {
    const scriptNode = document.createElement('script');
    scriptNode.src = `/dynatrace/dynatrace-${locale}.js`;
    document.head.appendChild(scriptNode);
  }
}

export { dynatraceInjection };
